import { ReactChild } from 'react';
import { FormattedNumber, WrappedComponentProps } from 'react-intl';
import { getCurrenySymbolFromCode } from '../helpers/currency';
import { getCountry } from './CountryProvider';

type FormattedCurrencyProps = {
    className?: string;
    decimalPlaces?: number;
    modifiedAmount?: (formattedNumber: string) => ReactChild;
    value: number;
};

const getDecimalPlaces = (value: number) => {
    if (value % 1 === 0) {
        return 0;
    } else {
        return 2;
    }
};

export function FormattedCurrency({
    className,
    value,
    decimalPlaces = 2,
    modifiedAmount
}: FormattedCurrencyProps) {
    return (
        <span className={className}>
            <FormattedNumber
                style="currency"
                currencyDisplay="symbol"
                currency={getCountry() === 'DE' ? 'EUR' : 'GBP'}
                maximumFractionDigits={decimalPlaces}
                minimumFractionDigits={decimalPlaces}
                value={value}
            >
                {modifiedAmount
                    ? (formattedNumber: string) => (
                          <>{modifiedAmount(formattedNumber)}</>
                      )
                    : undefined}
            </FormattedNumber>
        </span>
    );
}

export const intlFormatCurrency = ({
    intl,
    value,
    decimalPlaces
}: {
    value: number;
    decimalPlaces?: number;
} & WrappedComponentProps) => {
    if (decimalPlaces === undefined) {
        decimalPlaces = getDecimalPlaces(value);
    }

    if (getCountry() === 'DE') {
        return `${intl.formatNumber(value, {
            maximumFractionDigits: decimalPlaces,
            minimumFractionDigits: decimalPlaces
        })} ${getCurrenySymbolFromCode('EUR')}`;
    }

    return `${getCurrenySymbolFromCode('GBP')}${intl.formatNumber(value, {
        maximumFractionDigits: decimalPlaces,
        minimumFractionDigits: decimalPlaces
    })}`;
};
